export const CHANGE_INPUT_VALUE = `CHANGE_INPUT_VALUE`;

export const INIT_REQUEST = `INIT_REQUEST`;
export const INIT_SUCCESS = `INIT_SUCCESS`;
export const INIT_FAILURE = `INIT_FAILURE`;

export const SEARCH_REQUEST = `SEARCH_REQUEST`;
export const SEARCH_SUCCESS = `SEARCH_SUCCESS`;
export const SEARCH_FAILURE = `SEARCH_FAILURE`;

export const GET_CODERS_REQUEST = `GET_CODERS_REQUEST`;
export const GET_CODERS_SUCCESS = `GET_CODERS_SUCCESS`;
export const GET_CODERS_FAILURE = `GET_CODERS_FAILURE`;

export const SELECT_CODER = `SELECT_CODER`;
export const REMOVE_CODER = `REMOVE_CODER`;

export const BEGIN_WORK_REQUEST = `BEGIN_WORK_REQUEST`;
export const BEGIN_WORK_SUCCESS = `BEGIN_WORK_SUCCESS`;
export const BEGIN_WORK_FAILURE = `BEGIN_WORK_FAILURE`;
